import { graphql } from "@/lib/gql/__generated__";

export const EcReceiptDetail_ManagementECPage_Query = graphql(`
	query EcReceiptDetail_ManagementECPage($hotelID: ID!, $receiptID: ID!) {
		ecReceiptItem(hotelID: $hotelID, receiptID: $receiptID) {
			id
			hotelID
			receiptID
			guestName
			guestNameKana
			guestEmail
			guestTel
			guestPostalCode
			guestAddress
			purchasedDate
			totalGuestCharge
			purchasedItems {
				name
				amount
				eachPrice
			}
		}
		voucherIssuedByHotelIDAndReceiptID(hotelID: $hotelID, receiptID: $receiptID) {
			id
			voucherIssuedList {
				hotelID
				voucherCode
				userECReceiptID
				usedReservationID
				voucherMast {
					name
					description
					voucherPrice
					sellingPrice
				}
				useableStartDt
				cinStart
				cinEnd
				guestName
				guestEmail
				guestPostalCode
				guestAddress
				guestTel
				giftInfo {
					to
					from
					password
					message
				}
				createdAt
				createdDt
				usedAt
			}
		}
	}
`);
